import React, { useState } from 'react'
import ModalComponent from './ModalComponent'

import TeamLogos from "../assets/team_logo.json"


export default function ScoreEdit(props) {

    const [selected_logo, setSelectedLogo] = useState("")

    const [teamName, setTeamName] = useState("")

    const selectTeams = (team_item) => {
        setSelectedLogo(team_item)
    }

    const submitClick = () => {

        console.log(props.scoreUpdateParams)

        if (props.scoreUpdateParams == "A") {
            let data = {
                team_name_A: teamName,
                logo_A: selected_logo
            }
            props.teamDetails(data)
            setSelectedLogo("")
            setTeamName("")
        } else {
            let data = {
                team_name_B: teamName,
                logo_B: selected_logo
            }
            props.teamDetails(data)
            setSelectedLogo("")
            setTeamName("")
        }

        props.closeModal()
    }

    return (
        <div>
            {props.showScoreUpdateModal ?
                <ModalComponent>
                    <div class="modal-dialog">
                        <div class="modal-content">
                            <div class="modal-header">
                                <button type="button" class="btn-close" aria-label="Close" onClick={() => props.closeModal()}></button>
                            </div>
                            <div class="modal-body">

                                <label>Enter Team Name</label>
                                <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="eg : India" maxLength={65} required onChange={(e) => setTeamName(e.target.value)} />

                                <div className='mt-3'>
                                    <label>Select Team Logo</label>
                                    <div className='d-flex pt-1 flex-wrap' >

                                        {TeamLogos.teams.map((items, index) => (
                                            <img src={`https://images.mathrubhumi.com/images/liveblog/logos/${items}.png`} style={{ width: "60px", height: "60px", border: `2px solid ${selected_logo == items ? "#4990e0" : "white"}` }} onClick={() => selectTeams(items)} ></img>
                                        ))}
                                    </div>
                                </div>
                                <div className='d-flex justify-content-end mt-2'>
                                    <button type="button" class="btn btn-primary" onClick={() => submitClick()}>Submit</button>

                                </div>

                            </div>
                        </div>
                    </div>
                </ModalComponent> : ""}
        </div>
    )
}
